import script from "./ageCheck.vue?vue&type=script&lang=ts&setup=true"
export * from "./ageCheck.vue?vue&type=script&lang=ts&setup=true"

import "./ageCheck.vue?vue&type=style&index=0&id=7b68a486&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b68a486"]])

export default __exports__